import { Alert, Button, Form, Modal } from "react-bootstrap";
import { bodyStyleApi, BodyStyleModel } from "../../api/bodyStyleApi";
import { SyntheticEvent, useState } from "react";
import { formErrors, ValidationProblem } from "../../api/backendApi";

interface BodyStyleModalProps {
  bodyStyle: BodyStyleModel;
  isCreate: Boolean;
  onChange: (bodyStyleModel: BodyStyleModel) => void;
  onCancel: () => void;
  modalText: string;
}

function BodyStyleModal({
  bodyStyle: initialBodyStyle,
  isCreate,
  onChange,
  onCancel,
  modalText,
}: BodyStyleModalProps) {
  const [bodyStyle, setBodyStyle] = useState(initialBodyStyle);
  const [show, setShow] = useState(true);
  const [errors, setErrors] = useState<formErrors>({});

  const handleClose = () => {
    setShow(false);
    onCancel();
    setBodyStyle(initialBodyStyle);
  };

  const handleChange = (event: any) => {
    const { name, value } = event.target;

    const change = { [name]: value };
    const modified: BodyStyleModel = { ...bodyStyle, ...change };

    setBodyStyle(modified);
  };

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault();

    let call = isCreate
      ? bodyStyleApi.createBodyStyle(bodyStyle)
      : bodyStyleApi.updateBodyStyle(initialBodyStyle.style, bodyStyle);

    call.then((result) => {
      if (result.ok) {
        onChange(bodyStyle);
        handleClose();
      } else {
        let validation = result.problem as ValidationProblem;
        if (validation.validation) {
          setErrors(validation.validation);
        } else {
          let errors: formErrors = {};
          errors[""] = [`${result.problem.title} [${result.problem.instance}]`];
          setErrors(errors);
        }
      }
    });
  };

  const formEntries = [
    {
      title: "Style",
      value: "style",
    },
    {
      title: "English",
      value: "english",
    },
    {
      title: "Dutch",
      value: "dutch",
    },
    {
      title: "German",
      value: "german",
    },
    {
      title: "French",
      value: "french",
    },
    {
      title: "Spanish",
      value: "spanish",
    },
    {
      title: "Portuguese",
      value: "portuguese",
    },
    {
      title: "Italian",
      value: "italian",
    },
    {
      title: "Polish",
      value: "polish",
    },
    {
      title: "Czech",
      value: "czech",
    },
    {
      title: "Swedish",
      value: "swedish",
    },
    {
      title: "Danish",
      value: "danish",
    },
    {
      title: "Norwegian",
      value: "norwegian",
    },
    {
      title: "Finnish",
      value: "finnish",
    },
    {
      title: "Hungarian",
      value: "hungarian",
    },
    {
      title: "Croatian",
      value: "croatian",
    },
    {
      title: "Hebrew",
      value: "hebrew",
    },
    {
      title: "Slovene",
      value: "slovene",
    },
    {
      title: "Russian",
      value: "russian",
    },
    {
      title: "Arabic",
      value: "arabic",
    },
    {
      title: "Ukrainian",
      value: "ukrainian",
    },
  ];

  return (
    <>
      <Modal dialogClassName="modal-80w" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{modalText}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            noValidate
            style={{ maxHeight: "1000px", overflowY: "scroll" }}
            onSubmit={handleSubmit}
            id="bodyStyleForm"
          >
            {errors[""] && (
              <div style={{ marginTop: "1rem" }}>
                {errors[""].map((errorMessage, index) => (
                  <Alert key={errorMessage} variant="danger">
                    <p key={index}>{errorMessage}</p>
                  </Alert>
                ))}
              </div>
            )}
            {formEntries.map((f, index) => (
              <Form.Group key={index}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "10px",
                    maxHeight: "fit-content",
                  }}
                >
                  <Form.Label style={{ fontWeight: "500", minWidth: "100px" }}>
                    {f.title}
                  </Form.Label>
                  <div style={{ width: "100%" }}>
                    <Form.Control
                      name={f.value}
                      type="text"
                      value={(bodyStyle as any)[f.value] ?? ""}
                      onChange={handleChange}
                      size="sm"
                      isInvalid={
                        (errors as formErrors)[f.value]?.length === undefined ||
                        (errors as formErrors)[f.value]?.length === 0
                          ? false
                          : true
                      }
                    />
                    {(errors as formErrors)[f.value] &&
                      (errors as formErrors)[f.value].map((e) => (
                        <Form.Control.Feedback key={e} type="invalid">
                          {e}
                        </Form.Control.Feedback>
                      ))}
                  </div>
                </div>
              </Form.Group>
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" form="bodyStyleForm" type="submit">
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default BodyStyleModal;
